import { render, staticRenderFns } from "./sup_tasks.vue?vue&type=template&id=c6959b94&scoped=true&"
import script from "./sup_tasks.vue?vue&type=script&lang=js&"
export * from "./sup_tasks.vue?vue&type=script&lang=js&"
import style0 from "./sup_tasks.css?vue&type=style&index=0&id=c6959b94&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6959b94",
  null
  
)

export default component.exports